










































































import { Vue, Component, Watch } from "vue-property-decorator";
import { UserService } from "src/services";
import { IAccSettingModel } from "src/model";
import router from '../../router'

@Component
export default class Shop extends Vue
{
     /**
     * labelCol
     * @protected
     * @return any
     */
    protected labelCol: any = {
        xs: { span: 6 },
        sm: { span: 6 },
    };

     /**
     * wrapperCol
     * @protected
     * @return any
     */
    protected wrapperCol: any = {
        xs: { span: 15 },
        sm: { span: 15 },
    };

    /**
     * 表单验证规则
     * @protected
     * @return any
     */
    protected rules: any = {
    };

    /**
     * 表单数据
     * @protected
     * @return ICheckupItemModel
     */
    protected formData: IAccSettingModel = {
        avatar: this.userInfo.avatar

    };

    
    /**
     * 获取用户服务
     * @private
     * @return UserService
     */
    private _userService: UserService;

    /**
     * 获取或设置用户服务。
     * @protected
     * @returns UserService
     */
    protected get userService(): UserService
    {
        if(!this._userService)
        {
            this._userService = this.$serviceProvier.resolve<UserService>(UserService);
        }

        return this._userService;
    }

    /**
     * 上传头像文件流
     * @protected
     * @type {any}
     */
    protected file: any;

    /**
     * 用户信息
     * @protected
     * @type {any}
     */
    protected get userInfo(): any {

        return this.$store.getters["global/userInfo"]
    }
    
    /**
     * 修改密码
     * @protected
     * @returns void
     */
    protected changePasswordF(): void
    {
        this.$router.push({name: 'changePassword'});
    }

    /**
     * 组件创建钩子。
     * @protected
     * @returns void
     */
    protected created(): void
    {
        // this.getMyTenants();
    }

    /**
     * 图片变化
     * @protected
     */
    protected customRequest(file: any): void
    {
        this.file= file.file;
        this.getBase64(file.file).then(res=>
        {
            this.formData.avatar = window.URL.createObjectURL(res);
        })
    }

    /**
     * 获取base64
     * @protected
     */
    protected getBase64(file) {
        return new Promise((resolve, reject) =>
        {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(this.dataURItoBlob(reader.result));
            // reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    /**
     * base64转blob
     */
    protected dataURItoBlob(dataURI) {  
        var byteString = atob(dataURI.split(',')[1]);  
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];  
        var ab = new ArrayBuffer(byteString.length);  
        var ia = new Uint8Array(ab);  
        for (var i = 0; i < byteString.length; i++) {  
            ia[i] = byteString.charCodeAt(i);  
        }  

        return new Blob([ab], {type: mimeString});  
    }

    /**
     * 注销登录
     * @protected
     * @return void
     */
    protected async logout(): Promise<void> {
        try {
        await this.userService.logout();
        } catch (err) {
        this.$message.error({
            duration: 3,
            content: err || "服务器错误",
        });
        }
    }
    /**
     * 新增/编辑表单实例。
     * @protected
     * @returns any
     */
    public get $form(): any
    {
        return this.$refs.form as any;
    }
    /**
     * 修改账号信息
     * @protected
     */
    protected async onSubmit(parameter: any): Promise<any> {
        let _this = this;
        let data = Object.assign({}, this.formData);
        let formDataA = new FormData();
        if (this.file) 
        {
            formDataA.append("avatar", this.file);
        }
        this.$form.validate(async (valid: boolean)=>
        {
            if (valid) {
                try {
                    let { content:result} = await this.userService.skcuser(formDataA);
                    if(result.data)
                    {
                        for (let key in result.data) 
                        {
                            this.userInfo[key] = result.data[key];
                        }
                        this.$store.dispatch("global/setUserInfo", this.userInfo);
                    }
                    this.$message.success("修改成功！");
                    this.onCancel();
                } catch (err) {
                    this.$message.error(JSON.stringify(err));
                }
            }
        })
    }
     /**
     * 返回上一页
     * @protected
     */
    protected onCancel(): void
    {
        this.$router.go(-1);
    }

    /**
     * 退出登录
     * @protected
     * @returns void
     */
    protected loginOut(): void
    {
        this.$confirm({
      title: "提示",
      content: "是否确定注销登录 ?",
      okText: "确定",
      cancelText: "取消",
      onOk: async () => {
        return await this.logout()
          .then(() => {
            setTimeout(() => {
              localStorage.clear();
              this.$router.push("/")
            }, 20);
          })
          .catch(() => {
            this.$message.error("注销失败");
          });
      },
      onCancel() {},
    });
    }
     /**
     * 返回首页
     * @protected
     * @returns void
     */
    protected gotoIndex(): void
    {
       this.$router.push({name: 'shop'})
    }
    
}
